/* eslint-disable react/prop-types */
import Box from '@mui/material/Box';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import React from 'react';

class Message extends React.PureComponent {
  render() {
    if (this.props.visible) {
      return (
        <Box className="conferenceMessageContainer">
          <Box className="conferenceMessage">{this.props.message}</Box>
        </Box>
      );
    }

    return null;
  }
}

export default withBoundary(Message);
